const CONTRACTS = {
  SELEGO_NL: "SELEGO_NL",
  LE_COLLECTIF: "LE_COLLECTIF",
  FREELANCE: "FREELANCE",
};
const JOB_CONTRACTS = ["CDD", "CDI", "VIE", "INTERNSHIP", "APPRENTICESHIP", "FREELANCE", "Me kohe te plote"];
const JOB_POSITIONS = ["FULLSTACK", "CTO", "DATA", "DEVOPS", "PRODUCT", "SALES", "GROWTH", "DESIGN", "OTHER"];
const JOB_LOCATIONS = ["PARIS", "AMSTERDAM", "BARCELONE", "REMOTE", "TIRANA", "PARIS/AMSTERDAM/BARCELONE"];

const OFFICE = ["PARIS", "AMSTERDAM", "BARCELONE", "TIRANA", "ANY"];

const PAYMENTS = { PENDING: "PENDING", PAID: "PAID", TOPAY: "TOPAY", ERROR: "ERROR" };
const PAYMENT_METHODS = { PAYONEER: "PAYONEER", PAYPAL: "PAYPAL", TRANSFERWISE: "TRANSFERWISE", BANKTRANSFER: "BANKTRANSFER" };
const PERIOD = { MONTHLY: "MONTHLY", DAILY: "DAILY" };

const BUSINESS_UNIT = {
  SELEGO: "SELEGO",
  TIRANA: "TIRANA",
  WALEGO: "WALEGO",
};

const PROJECT_TYPE_COLORS = {
  prospection: {
    textColor: "text-[#85a29a]",
    backgroundColor: "bg-[#dbfff5]",
  },
  "startup-project": {
    textColor: "text-[#7CB255]",
    backgroundColor: "bg-[#E5FED6]",
  },
  "startup-invest": {
    textColor: "text-[#958f74]",
    backgroundColor: "bg-[#fff5d2]",
  },
  admin: {
    textColor: "text-[#9f8fa2]",
    backgroundColor: "bg-[#fbe7ff]",
  },
};

const SUPPORT_LABELS = {
  CONTRACT: "CONTRACT",
  INVOICE: "INVOICE",
  PAYMENT: "PAYMENT",
  TOOLS: "TOOLS",
  RECRUITMENT: "RECRUITMENT",
  ADMIN: "ADMIN",
  FINANCE: "FINANCE",
};

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const YEARS = [2021, 2022, 2023, 2024, 2025];

const CATEGORIES_KEY_WORDS = ["FRONT", "BACK", "AI", "MOBILE", "DEVOPS", "SECURITY", "DATA", "PRODUCT", "ACQUISITION", "GTM", "TOOLS", "DESIGN", "OTHER"];

export {
  CONTRACTS,
  PAYMENTS,
  PERIOD,
  PAYMENT_METHODS,
  PROJECT_TYPE_COLORS,
  SUPPORT_LABELS,
  MONTHS,
  YEARS,
  JOB_CONTRACTS,
  JOB_POSITIONS,
  OFFICE,
  JOB_LOCATIONS,
  BUSINESS_UNIT,
  CATEGORIES_KEY_WORDS,
};
